import type { Flow, FlowId, FlowUpdateInput } from '@grafx-vdp/shared';

import { apiFetch } from './client.js';

export interface ListFlowsResponse {
  flows: Flow[];
}

export function listFlows(jwt: string | null): Promise<ListFlowsResponse> {
  return apiFetch<ListFlowsResponse>('/api/flows', { jwt, method: 'GET' });
}

export interface GetFlowResponse {
  flow: Flow;
}

export function getFlow(jwt: string | null, flowId: FlowId): Promise<GetFlowResponse> {
  return apiFetch<GetFlowResponse>(`/api/flows/${encodeURIComponent(flowId)}`, {
    jwt,
    method: 'GET',
  });
}

export interface UpdateFlowResponse {
  flow: Flow;
}

export function updateFlow(
  jwt: string | null,
  flowId: FlowId,
  input: FlowUpdateInput,
): Promise<UpdateFlowResponse> {
  return apiFetch<UpdateFlowResponse>(`/api/flows/${encodeURIComponent(flowId)}`, {
    jwt,
    method: 'PUT',
    json: input,
  });
}
